<template>
  <section class="news-view first-section section-slate">

    <div class="news-view-hero" v-if="showHero">
      <div class="container full-width-small">
        <AppImage :src="image" :alt=post.title class="yellow-border" />
      </div>
    </div>


    <div class="news-view-column" v-if="post">

      <div class="news-view-meta">
        <p class="news-view-date roboto-condensed">{{post.modified | formatDate}}</p>
        <p class="news-view-title roboto-condensed">{{post.title}}</p>

        <div class="news-view-copy"  v-html="post.content">
        </div>
      </div>

      <LatestNews title="recent_news" position="news_view" :slug=slug />
    </div>


  </section>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import LatestNews from '@/components/ui/news/LatestNews';
import AppImage from '@/components/ui/AppImage';


export default {
  name: 'NewsView',
  props: ['slug'],
  components: {
    LatestNews,
    AppImage
  },
  data() {
    return {
      hasPosts: false
    }
  },
  created() {
    if(this.posts.length == 0) {
      this.getPosts().then(() => {
        this.hasPosts = true;
      });
    } else {
      this.hasPosts = true;
    }
  },
  computed: {
    ...mapGetters({
      posts: 'posts'
    }),
    post() {
      if(!this.hasPosts) return false;
      let post = false;

      post = this.posts.find(f => f.slug === this.slug);

      if(post == undefined) {
        this.$router.push({ name: 'error' });
      }

      return post;
    },
    image() {
      if(this.post.hasOwnProperty('images')) {
        return this.post.images.large;
      } else {
        return false;
      }
    },
    showHero() {
      return (this.post && this.post.hasOwnProperty('images')) ? true : false;
    }
  },
  methods: {
    ...mapActions({
      getPost: 'getPost',
      getPosts: 'getPosts'
    })
  }
};

</script>

<style lang="scss">
  section.news-view {
    padding-bottom: 5vw;

    .wp-block-image img {
      display: block;
      max-width: 100%;
      margin: 3vw 0;
      @include bp($max-width) {
        margin: 35px 0;
      }
    }
    .news-view-copy p {
      margin-bottom: 3vw;
      @include bp($bp--m) {
        margin-bottom: 1vw;
      }
    }
  }

  .news-view-hero {
    @include bp($bp--s, false) {
      .image-wrapper {
        padding: 0;
      }
      .image-background {
        padding: 0;
      }
    }
    .image-content:before {
      padding-top: (699/1254) * 100%;
    }
  }
  .news-view-hero {
    padding-top: 5vw;
    @include bp($max-width) {
      padding-top: 125px;

    }
  }
  .news-view-meta {
    padding-top: 6vw;
    @include bp($bp--m, false) {
      padding-left: 20px;
      padding-right: 20px;
    }
    @include bp($bp--m) {
      padding-top: 4vw;
      padding-right: 4vw;
    }
    @include bp($max-width) {
      padding-top: 50px;
      padding-right: 80px;
    }

  }
  .news-view-date {
    color: $grey;
    font-weight: bold;
    font-size: 10px;
    margin-bottom: 3vw;

    @include bp($bp--m) {
      font-size: 14px;
      margin-bottom: 2vw;
    }

    @include bp($max-width) {
      margin-bottom: 30px;
    }
  }

  .news-view-title {
    color: $blue;
    font-weight: bold;
    font-size: 15px;
    line-height: 15px;
    text-transform: uppercase;
    margin-bottom: 2vw;
    @include bp($bp--m) {
      font-size: 28px;
      line-height: 36px;
      margin-bottom: 3vw;
    }
    @include bp($max-width) {
      margin-bottom: 30px;
    }
  }

  .news-view-copy {
    color: $grey;
    font-size: 15px;
    line-height: 21px;

    em {
      font-style: italic;
    }

    ul li {
      list-style: disc;
      list-style-position: inside;
    }

    ol li {
      list-style: decimal;
      list-style-position: inside;
    }

  blockquote{
  font-size: 1.4em;
  width:100%;
  margin:40px auto;
  font-style:italic;
  color: #555555;
  padding:1.2em 50px;
  //border-left:8px solid #555555 ;
  line-height:1.6;
  position: relative;
  //background:#EDEDED;
  * {
    color: #555555!important;
  }
}

blockquote::before{
  font-family:Arial;
  content: "\201C";
  color:#555555;
  font-size:3em;
  position: absolute;
  left: 10px;
  top:-10px;
}

blockquote::after{
  font-family:Arial;
  content: "\201D";
  color:#555555;
  font-size:3em;
  position: absolute;
  right: 20px;
  bottom:-50px;
}




    img {
      display: block;
      max-width: 100%;
      height: auto;
    }
    .videoWrapper {
      position: relative;
      padding-bottom: 56.25%; /* 16:9 */
      height: 0;
    }
    .videoWrapper iframe, .videoWrapper div, .videoWrapper video {
      position: absolute;
      top: 0;
      left: 0;
      width: 100% !important;
      height: 100% !important;
    }
    .wp-video {
      width: auto!important;
      video {
        display: block;
        width: 100%!important;
        height: 100%;
      }
    }

    a {
      text-decoration: underline;
      color: $blue;
    }

    h1, h2, h3, h4, h5, h6 {
      font-family: 'Roboto Condensed', sans-serif;
      font-weight: bold;
      text-transform: uppercase;
    }
    h1 {
        font-size: 32px;
        line-height: 38px;
        margin: 35px 0;
    }

    h2 {
        font-size: 28px;
        line-height: 36px;
        margin: 30px 0;
    }
    h3 {
      font-size: 24px;
      line-height: 28px;
      margin: 25px 0;
    }

    h4 {
      font-size: 22px;
      line-height: 26px;
      margin: 20px 0;
    }

    h5 {
      font-size: 20px;
      line-height: 24px;
      margin: 15px 0;
    }
    h6 {
      font-size: 18px;
      line-height: 22px;
      margin: 10px 0;
    }
  }



  .news-view-column {
    position: relative;
    // Removing as it causes the local select to go behind on small screen
    //z-index: 3;

    @include bp($bp--m) {
      display: grid;
      grid-template-columns: minmax(60%, 1fr) minmax(300px, 470px);
      max-width: $max-width;
      margin: 0 auto;
      padding: 0 20px;
    }

    @include bp($max-width + 40) {
      //padding: 0;
      // Removing as it causes news column to be wider than hero on large screens
    }

    .latest-news {
      padding-top: 50px;
      // TODO:
      // Replace with news border image
      border-image: url('~@/assets/images/border-mask-news.png');
      border-image-repeat: stretch repeat;
      border-image-slice: 70 175 fill;
      border-image-width: 10% 15%;

      @include bp($bp--m) {
        margin-top: 3vw;
      }
      @include bp($max-width) {
        margin-top: 50px;
      }
    }
  }

  .wp-block-gallery {
    display: flex;
    flex-wrap: wrap;
    &.aligncenter {
      justify-content: center;
    }
  }
  .blocks-gallery-item {
    margin: 0 16px 16px 0;
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    justify-content: center;
    position: relative;
    text-align: center;
}

// WP styles
.wp-block-columns {
  display: flex;
 // background: blue;
}

.wp-block-column {
  flex: 1;
  //background: orange;
  justify-content: center;

  figure {
    display: flex;
    justify-content: center;
  }
}
.has-2-columns {
  max-width: 300px;
  margin: 0 auto;
}
.wp-block-columns {
 // margin: 20px 0;
}

/* Add horiztonal breathing room between individual columns. */
.wp-block-column {
  //margin: 0 20px;
}

figure.aligncenter {
  display: flex;
  justify-content: center;
}

</style>



// WEBPACK FOOTER //
// src/pages/NewsView.vue